import TabNav from 'components/global/TabNav';
import { $detail, $view } from 'signals/global.signals';
import { Button, Col, Image, Row } from 'react-bootstrap';
import { handleShowModal } from 'components/global/_helpers/global.helpers';
import FounderInviteUserModal from 'components/views/FounderTeam/_components/FounderInviteUserModal';
import { fetchAndSetFounderCompanyOptionsAndDetail } from 'components/views/FounderTeam/_helpers/founderTeam.resolvers';
import useEffectAsync from 'utils/useEffectAsync';
import DefaultAvatar from 'components/global/DefaultAvatar';
import withDismount from 'hocs/withDismount';
import FounderPeople from './_components/FounderPeople';
import FounderInvites from './_components/FounderInvites';

const FounderTeam = () => {
  useEffectAsync(fetchAndSetFounderCompanyOptionsAndDetail);

  return (
    <>
      <Row className="mb-24">
        <Col>
          <div className="d-flex flex-md-row flex-column align-items-center">
            <div
              className="d-flex justify-content-center rounded-circle flex-shrink-0 profileSettingsAvatar mb-md-0 mb-16"
            >
              {$view.value.logo
                ? <Image src={$detail.value.logo} className="w-100 h-100" style={{ objectFit: 'cover' }} />
                : <DefaultAvatar name={$detail.value.organizationName} styleArr={$detail.value.logoColors} className="profileDefaultSettingsAvatar" />}
            </div>
            <div className="d-flex flex-column ms-md-32 ms-0 align-items-md-start align-items-center">
              <p className="m-0 h3 fw-600">
                {$detail.value.organizationName}
              </p>
            </div>
          </div>
        </Col>
        <Col className="text-end">
          <Button
            variant="primary"
            onClick={() => handleShowModal('invite-user')}
          >
            Invite User
          </Button>
        </Col>
      </Row>
      <TabNav
        tabs={['Users', 'Pending Invites']}
        TabComponents={[<FounderPeople />, <FounderInvites />]}
        activeTab={$view.value.activeTab}
        async
      />
      <FounderInviteUserModal />
    </>
  );
};

export default withDismount(FounderTeam);
